import { DEFAULT_AVATAR_URL } from '@/const';
import { IUser } from '@/types/models';

function getAvatarUrl(user: IUser | undefined): string {
  return user?.avatarUrl || DEFAULT_AVATAR_URL;
}

export default getAvatarUrl;
